(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-kmd-nav-root]';
  var NONE = 'none';
  var UNKNOWN = 'unknown';

  function valueOr(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    return String(value).slice(0, 100);
  }

  function destinationFor(element) {
    var configuredDestination = element.getAttribute('data-nav-destination');
    if (configuredDestination) return valueOr(configuredDestination, NONE);

    var href = element.getAttribute('href');
    if (!href) return NONE;

    try {
      var url = new URL(href, window.location.href);
      var destination = url.hostname === window.location.hostname
        ? url.pathname
        : url.hostname + url.pathname;

      return valueOr(destination, NONE);
    } catch (error) {
      return valueOr(href, NONE);
    }
  }

  function pushNavEvent(root, eventName, parameters) {
    parameters = parameters || {};
    window.dataLayer = window.dataLayer || [];

    // Every key is reset on every event so GTM does not inherit a value from
    // an earlier navigation event in the data layer's internal state.
    window.dataLayer.push({
      event: eventName,
      nav_type: valueOr(parameters.nav_type, UNKNOWN),
      menu_name: valueOr(parameters.menu_name, NONE),
      nav_parent: valueOr(parameters.nav_parent, NONE),
      nav_item: valueOr(parameters.nav_item, NONE),
      nav_level: valueOr(parameters.nav_level, NONE),
      nav_position: valueOr(parameters.nav_position, NONE),
      destination_path: valueOr(parameters.destination_path, NONE),
      page_type: valueOr(root.getAttribute('data-page-type'), UNKNOWN),
      nav_version: valueOr(root.getAttribute('data-nav-version'), 'current_v1'),
      interaction_method: valueOr(parameters.interaction_method, NONE)
    });
  }

  function trackImpression(root) {
    var tracked = false;

    function sendImpression() {
      if (tracked) return;
      tracked = true;

      pushNavEvent(root, 'nav_impression', {
        nav_type: window.matchMedia('(max-width: 989px)').matches ? 'mobile' : 'desktop',
        menu_name: 'header',
        interaction_method: 'view'
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRect.height > 0) {
            sendImpression();
            observer.disconnect();
          }
        });
      });

      observer.observe(root);
      return;
    }

    if (root.getClientRects().length > 0) sendImpression();
  }

  function trackClicks(root) {
    root.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;

      var element = event.target.closest('[data-nav-track]');
      if (!element || !root.contains(element)) return;

      pushNavEvent(root, 'nav_click', {
        nav_type: element.getAttribute('data-nav-type'),
        menu_name: element.getAttribute('data-menu-name'),
        nav_parent: element.getAttribute('data-nav-parent'),
        nav_item: element.getAttribute('data-nav-item'),
        nav_level: element.getAttribute('data-nav-level'),
        nav_position: element.getAttribute('data-nav-position'),
        destination_path: destinationFor(element),
        interaction_method: event.detail === 0 ? 'keyboard' : 'click'
      });
    });
  }

  function trackMobileDrawer(root) {
    var drawer = root.querySelector('[data-nav-main-drawer]');
    if (!drawer) return;

    drawer.addEventListener('toggle', function () {
      pushNavEvent(root, drawer.open ? 'nav_open' : 'nav_close', {
        nav_type: 'mobile_drawer',
        menu_name: 'main',
        interaction_method: 'toggle'
      });
    });
  }

  function trackMobileSubmenus(root) {
    root.querySelectorAll('header-drawer details[data-nav-submenu]').forEach(function (menu) {
      menu.addEventListener('toggle', function () {
        pushNavEvent(root, menu.open ? 'nav_open' : 'nav_close', {
          nav_type: 'mobile_submenu',
          menu_name: menu.getAttribute('data-menu-name'),
          nav_parent: menu.getAttribute('data-nav-parent'),
          nav_level: menu.getAttribute('data-nav-level'),
          interaction_method: 'toggle'
        });
      });
    });
  }

  function trackDesktopMenus(root) {
    root.querySelectorAll('.header__inline-menu details[data-nav-desktop-menu]').forEach(function (menu) {
      var hoverTimer;
      var trackedOpen = false;

      function sendOpen(method) {
        if (trackedOpen) return;
        trackedOpen = true;

        pushNavEvent(root, 'nav_open', {
          nav_type: 'desktop_mega',
          menu_name: menu.getAttribute('data-menu-name'),
          nav_level: '1',
          interaction_method: method
        });
      }

      function sendClose(method) {
        if (!trackedOpen) return;
        trackedOpen = false;

        pushNavEvent(root, 'nav_close', {
          nav_type: 'desktop_mega',
          menu_name: menu.getAttribute('data-menu-name'),
          nav_level: '1',
          interaction_method: method
        });
      }

      menu.addEventListener('mouseenter', function () {
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () {
          if (menu.matches(':hover')) sendOpen('hover');
        }, 350);
      });

      menu.addEventListener('mouseleave', function () {
        window.clearTimeout(hoverTimer);
        sendClose('hover_leave');
      });

      // Captures keyboard activation and closes initiated without a mouseleave.
      menu.addEventListener('toggle', function () {
        var summary = menu.querySelector(':scope > summary');
        var keyboardOpen = menu.open && summary === document.activeElement && !menu.matches(':hover');

        if (keyboardOpen) sendOpen('keyboard');
        if (!menu.open) sendClose('toggle');
      });
    });
  }

  function trackToggleControls(root) {
    root.querySelectorAll('details[data-nav-toggle-track]').forEach(function (control) {
      control.addEventListener('toggle', function () {
        if (!control.open) return;

        pushNavEvent(root, 'nav_click', {
          nav_type: control.getAttribute('data-nav-type'),
          menu_name: control.getAttribute('data-menu-name'),
          nav_parent: control.getAttribute('data-nav-parent'),
          nav_item: control.getAttribute('data-nav-item'),
          nav_level: control.getAttribute('data-nav-level'),
          nav_position: control.getAttribute('data-nav-position'),
          destination_path: control.getAttribute('data-nav-destination'),
          interaction_method: 'toggle'
        });
      });
    });
  }

  function initializeRoot(root) {
    if (!root || root.getAttribute('data-nav-tracking-initialized') === 'true') return;
    root.setAttribute('data-nav-tracking-initialized', 'true');

    trackImpression(root);
    trackClicks(root);
    trackMobileDrawer(root);
    trackMobileSubmenus(root);
    trackDesktopMenus(root);
    trackToggleControls(root);
  }

  function initializeAll(scope) {
    scope = scope || document;

    if (scope.matches && scope.matches(ROOT_SELECTOR)) initializeRoot(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initializeRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
